import whenDomReady from "when-dom-ready";
import renderFromPreloadedJSON from "~/common/renderFromPreloadedJSON";
import FoodServiceResourcesHeader from "./FoodServiceResourcesHeader";

whenDomReady(() => {
  renderFromPreloadedJSON(
    FoodServiceResourcesHeader,
    "FoodServiceResourcesHeader",
  );
});
